var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.5,
    height: 14.5,
    viewBox: "0 0 14.5 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ban-svgrepo-com",
    d: "M7.75.75a7,7,0,1,0,7,7h0a7.008,7.008,0,0,0-7-7h0Zm5.852,7v0a5.8,5.8,0,0,1-1.3,3.668l.008-.011L4.042,3.226a5.849,5.849,0,0,1,9.56,4.52v0h0Zm-11.7,0V7.745a5.8,5.8,0,0,1,1.34-3.718l-.008.01,8.278,8.193A5.847,5.847,0,0,1,1.9,7.755V7.75h0Z",
    transform: "translate(-0.5 -0.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanSvgrepoCom);
export default __webpack_public_path__ + "static/media/ban-svgrepo-com.9c7eb29d66e2acbbf447372949806ff8.svg";
export { ForwardRef as ReactComponent };